import styled, { css } from "styled-components/macro";

/* Wrapper around the trigger element */
export const CustomTooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  overflow: hidden;

  &.talent-update-roster {
    display: flex;
    align-items: center;
    width: 40px;
  }

  &.link-dropdown {
    position: relative;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

/* The actual tooltip box */
export const CustomTooltip = styled.div`
  position: absolute;
  border-radius: 8px;
  padding: 8px;
  width: fit-content;
  border-radius: 4px;
  border: 1px solid var(--Neutral-60, #fff);
  background: ${({ $theme }) => ($theme === "dark" ? "#4C4C4C" : "#FFFFFF")};
  color: ${({ $theme }) => ($theme === "dark" ? "#fff" : "#1f1f1f")};
  box-shadow:
    0px 91px 25px 0px rgba(80, 80, 80, 0),
    0px 58px 23px 0px rgba(80, 80, 80, 0.01),
    0px 33px 20px 0px rgba(80, 80, 80, 0.05),
    0px 15px 15px 0px rgba(80, 80, 80, 0.09),
    0px 4px 8px 0px rgba(80, 80, 80, 0.1);
  word-break: break-word;
  white-space: normal;
  z-index: 9999;
  transition: opacity 0.2s ease-in-out;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.014px;
  display: flex;
  align-items: center;
  gap: 4px;

  &.creator-manager-content {
    max-width: 224px;
  }
`;

/* Label text inside tooltip */
export const TooltipLabel = styled.div`
  color: ${({ $theme }) => ($theme === "dark" ? "#ffffff" : "#1F1F1F")};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.012px;
  /* max-width: 200px; */
  /* width: 100%; */
`;

/* Subheading / secondary text */
export const TooltipSubHeading = styled.div`
  font-size: 12px;
  color: ${({ $theme }) => ($theme === "dark" ? "#AAAAAA" : "#666666")};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.012px;
`;

/* Optional icon container */
export const TooltipIcon = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  color: ${({ $theme }) => ($theme === "dark" ? "#1f1f1f" : "#666666")};

  svg {
    width: 12px;
    height: 12px;
  }
`;

/* Optional small helper for custom content */
export const TooltipContent = styled.div`
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: ${({ $theme }) => ($theme === "dark" ? "#CCCCCC" : "#1F1F1F")};
`;

/* For different placements if you want later (top/bottom/left/right) */
export const TooltipPlacement = css`
  &.top {
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-4px);
  }
  &.bottom {
    top: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(4px);
  }
  &.left {
    right: 100%;
    top: 50%;
    transform: translateX(-4px) translateY(-50%);
  }
  &.right {
    left: 100%;
    top: 50%;
    transform: translateX(4px) translateY(-50%);
  }
`;
